'use client';

import { useLocale } from 'next-intl';
import React from 'react';

import { ShowingInfoModal } from '@/components/showing-details/ShowingInfoModal';

import { ShowingDto } from '@cineamo/api/models/showing/ShowingDto.types';

import { useCachedContentData } from '@/hooks/useCachedContentData';
import { useShowingTags } from '@cineamo/composables/src/hooks/showing/useShowingTags';

import { useCheckoutShowingInfo } from '@cineamo/composables/src/ticket-booking/showing-info-context';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

type BookingShowingInfoModalProps = {
    showing: ShowingDto;
};

/** The website's showing info, without share and buy buttons, for the checkout's "Details". */
export default function BookingShowingInfoModal(props: BookingShowingInfoModalProps): React.JSX.Element {
    const { showing } = props;
    const { isOpen, close: onClose } = useCheckoutShowingInfo();
    const locale = useLocale();
    const { cinema } = useDomainConfiguration();
    const { data: content } = useCachedContentData({ content: showing._embedded?.content, cinema, locale, showing });
    const { data: showingTags } = useShowingTags({ showingId: showing.id, enabled: isOpen });

    return (
        <>
            {isOpen && (
                <ShowingInfoModal
                    showing={showing}
                    content={content}
                    specials={showingTags?._embedded?.['showing-tags'] ?? []}
                    modalIsOpen={isOpen}
                    setModalIsOpen={(value) => {
                        if (!(typeof value === 'function' ? value(isOpen) : value)) onClose();
                    }}
                    onClose={() => onClose()}
                    showActions={false}
                />
            )}
        </>
    );
}
